module.exports = "/resources/assets/prod/e22504dddffa5f6081b6fd3323f6f7db.svg";